import React, { memo } from 'react';
import cn from 'classnames';

import { getIcons } from './Icon.helpers';

import styles from './Icon.module.scss';

import type { IconProps } from './Icon.types';

const Icon = ({ className, name, ...restProps }: IconProps) => {
  const icons = getIcons();
  const IconComponent = icons[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent {...restProps} className={cn(styles.icon, className)} />
  );
};

export default memo(Icon);
